import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_INTERNSHIPS, 
    ADD_NEW_INTERNSHIP, 
    UPDATE_INTERNSHIP, 
    DELETE_INTERNSHIP 
} from "./actionTypes";
import {
    getInternshipsSuccess,
    getInternshipsFail,
    addInternshipSuccess,
    addInternshipFail,
    updateInternshipSuccess,
    updateInternshipFail,
    deleteInternshipSuccess,
    deleteInternshipFail,
   
} from "./actions"

import {
    getInternships,
    addNewInternship,
    updateInternship,
    deleteInternship,
   
} from "helpers/internships/internships_backend_helper";
import { toast } from "react-toastify";

function* fetchInernships() {
    try {
        const response = yield call(getInternships)

        yield put(getInternshipsSuccess(response))
    } catch (error) {
        yield put(getInternshipsFail(error))
    }
}

function* onAddNewInternship({ payload }) {
    try {

        
        const response = yield call(addNewInternship, payload)

        console.log("RESPONSE:", response);
        yield put(addInternshipSuccess(response.internship))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addInternshipFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateInternship({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateInternship, payload)
        yield put(updateInternshipSuccess(response.internship))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateInternshipFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteInternship({ payload: data }) {

    try {
        const response = yield call(deleteInternship, data)
        yield put(deleteInternshipSuccess(response.internshipId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteInternshipFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* internshipSaga() {
    yield takeEvery(GET_INTERNSHIPS, fetchInernships)
    yield takeEvery(ADD_NEW_INTERNSHIP, onAddNewInternship)
    yield takeEvery(UPDATE_INTERNSHIP, onUpdateInternship)
    yield takeEvery(DELETE_INTERNSHIP, onDeleteInternship)
}

export default internshipSaga;